const PLACEHOLDER = '{{POST_BUILD_ENTERS_HASH_HERE}}';

export function getBuildHash(): string {
    // Prefer meta (exists before any JS runs)
    const meta = document.querySelector('meta[name="build-hash"]') as HTMLMetaElement | null;
    const fromMeta = meta?.getAttribute('content');

    // Fallback to global injected by main.ts or post-build
    const fromGlobal = (window as any).__BUILD_HASH__;

    const val = (fromMeta ?? fromGlobal ?? '').toString();

    return !val || val === PLACEHOLDER ? 'local' : val;
}
